import $ from "jquery";
import TemplateView from "./TemplateView";

export default class WindowSizeDependedView extends TemplateView {
    afterRender() {
        $(window).resizeThrottle(() => this.adjustSize(), 100);
        $(document).on("navigationResize", () => this.adjustSize());
        this.adjustSize();
    }

    adjustSize() {
        this.$el.adjustHeightToWindowSize();
    }
}


// WEBPACK FOOTER //
// ./web/js/WindowSizeDependedView.js